import { render } from "./MainArea.vue?vue&type=template&id=587626a9&scoped=true&ts=true"
import script from "./MainArea.vue?vue&type=script&lang=ts"
export * from "./MainArea.vue?vue&type=script&lang=ts"

import "./MainArea.vue?vue&type=style&index=0&id=587626a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587626a9"]])

export default __exports__